<template>
  <b-row>
    <b-col v-if="!savedCardsLoaded">
      <WaveSpinner/>
    </b-col>
    <b-col v-else-if="noSavedCards">
      You have no saved cards. Please add one in Billing first.
    </b-col>
    <template v-else>
      <b-col sm="7">
        <b-form-group label="Select a saved card">
          <b-form-select v-model="saved_card" :options="savedCardOptions">
            <!-- note: no "new card" option -->
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="5" class="text-right mt-3 mt-sm-0 mb-3">
        <ActionButton
          action="approveOrder"
          :arg="{saved_card}"
          success="Order Approved"
          variant="success"
          class="d-lg-block mb-lg-3">Pay &amp; Approve Order</ActionButton>
      </b-col>
    </template>
  </b-row>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
export default {
  data() {
    return {saved_card: null}
  },
  computed: {
    ...mapGetters(['savedCards', 'savedCardsLoaded', 'defaultSavedCard', 'loggedIn']),
    savedCardOptions() {
      return this.savedCards.map(c => ({value: c.id, text: c.title}));
    },
    noSavedCards() {
      return this.savedCardsLoaded && this.savedCards.length === 0;
    }
  },
  methods: {
    ...mapActions(['loadSavedCards']),
    async onMount() {
      await this.loadSavedCards();
      this.saved_card = this.saved_card || this.defaultSavedCard;
    }
  },
  mounted() {
    this.onMount();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/orders/PaymentRow.vue